/**
 * Strip "Brainchild – " prefix from Select2 dropdowns used for
 * Plakat line item properties on product pages.
 *
 * Targets only <select> elements where name starts with
 * "properties[Plakat " and their associated Select2 UI containers.
 * The underlying option values are NOT modified, so the full product
 * name is still submitted as a line item property at checkout.
 */
(function () {
  'use strict';

  const PREFIX = /^Brainchild\s*[–-]\s*/i;
  const SELECT_SELECTOR = 'select[name^="properties[Plakat "]';
  const DEBOUNCE_MS = 50;

  function stripTextNodes(node) {
    if (!node) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    let textNode;
    while ((textNode = walker.nextNode())) {
      const cleaned = textNode.nodeValue.replace(PREFIX, '');
      if (cleaned !== textNode.nodeValue) {
        textNode.nodeValue = cleaned;
      }
    }
  }

  function clean() {
    const selects = document.querySelectorAll(SELECT_SELECTOR);
    if (!selects.length) return;

    selects.forEach(function (select) {
      // Clean the native <option> elements
      select.querySelectorAll('option').forEach(function (opt) {
        const cleaned = opt.textContent.replace(PREFIX, '');
        if (opt.textContent !== cleaned) {
          opt.textContent = cleaned;
        }
      });

      if (!select.id) return;

      // Clean the closed Select2 box
      const rendered = document.getElementById('select2-' + select.id + '-container');
      if (rendered) {
        stripTextNodes(rendered);
        if (rendered.title) {
          rendered.title = rendered.title.replace(PREFIX, '');
        }
      }

      // Clean the open Select2 results list
      const results = document.getElementById('select2-' + select.id + '-results');
      if (results) {
        results.querySelectorAll('li span').forEach(stripTextNodes);
      }
    });
  }

  let debounceTimer = null;
  function scheduleClean() {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      clean();
    }, DEBOUNCE_MS);
  }

  function init() {
    clean();

    const observer = new MutationObserver(scheduleClean);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();